export function ParsedDate(strDate, hide) {
  let strSplitDate = String(strDate).split(" ");
  let date = new Date(strSplitDate[0]);
  let dd = date.getDate();
  let mm = date.getMonth() + 1;

  let yyyy = date.getFullYear();
  if (hide == "years") {
    date = dd + " " + listMonth(mm);
  } else {
    date = dd + " " + listMonth(mm) + " " + yyyy;
  }
  return date.toString();
}

function listMonth(month) {
  switch (month) {
    case 1:
      return "Jan";
    case 2:
      return "Feb";
    case 3:
      return "Mar";
    case 4:
      return "Apr";
    case 5:
      return "May";
    case 6:
      return "June";
    case 7:
      return "July";
    case 8:
      return "Aug";
    case 9:
      return "Sept";
    case 10:
      return "Oct";
    case 11:
      return "Nov";
    case 12:
      return "Dec";
    default:
      break;
  }
}
